/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type PCCItemDecisionReason = typeof PCCItemDecisionReason[keyof typeof PCCItemDecisionReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PCCItemDecisionReason = {
  TempoDayOneCreated: 'TempoDayOneCreated',
  TempoPendingReused: 'TempoPendingReused',
  TempoDayTwoCreated: 'TempoDayTwoCreated',
  TempoOrgDisabled: 'TempoOrgDisabled',
  TempoNotEnrolled: 'TempoNotEnrolled',
  TempoNoAppointment: 'TempoNoAppointment',
  TempoDayTwoNotDue: 'TempoDayTwoNotDue',
  RtmCheckInCreated: 'RtmCheckInCreated',
  RtmCheckInReused: 'RtmCheckInReused',
  RtmEnrollmentTokenMinted: 'RtmEnrollmentTokenMinted',
  RtmEnrollmentTokenReused: 'RtmEnrollmentTokenReused',
  RtmOrgDisabled: 'RtmOrgDisabled',
  RtmNotEligible: 'RtmNotEligible',
  RtmNoQualification: 'RtmNoQualification',
  RtmCheckInNotPending: 'RtmCheckInNotPending',
  CcmIncluded: 'CcmIncluded',
  CcmGoalCompleted: 'CcmGoalCompleted',
  CcmOrgDisabled: 'CcmOrgDisabled',
  CcmNotEligible: 'CcmNotEligible',
  CcmOptedOut: 'CcmOptedOut',
  CcmNotEnrolled: 'CcmNotEnrolled',
  TempoNotEligible: 'TempoNotEligible',
} as const;
